// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getColor from "@insite/mobius/utilities/getColor";
import customProductListActionsStyle from "@rugby/Overrides/Widgets/ProductList/styles/ProductListActions.style";
import checkboxDefaultTheme from "@rugby/XDL/PreStyle/checkbox";
import { css } from "styled-components";

const imageSize = {
    width: 274,
    height: 198,
};

const customProductCardStyles = {
    container: {
        wrapper: {
            css: css`
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;

                width: 100%;
                min-height: ${imageSize.height}px;

                padding-right: 20px;
                margin-bottom: 30px;

                border: 1px solid ${getColor("common.border")};
                background-color: ${getColor("common.white")};
            `,
        },
        infoWrapper: {
            css: css`
                display: flex;
                flex: 1 0 73%;
                > div:first-child {
                    margin-right: 30px;
                }

                position: relative;

                // to draw line
                &:after {
                    content: "";
                    position: absolute;
                    top: 50%;
                    right: 0;
                    transform: translateY(-50%);

                    height: calc(100% - 20px * 2);
                    width: 1px;
                    background-color: ${getColor("common.border")};
                    display: ${props => {
                        return (props as any).isParent ? "none" : "initial";
                    }};
                }
            `,
        },
        actionWrapper: {
            css: css`
                flex: 0 1 26%;
                padding: 25px 0px 20px 20px;
            `,
        },
    },
    productListProductImage: {
        wrapper: {
            css: css`
                // we need height 100% to solve extra space when add product attributes to card
                height: 100%;

                width: ${imageSize.width}px;
                min-height: ${imageSize.height}px;
                min-width: ${imageSize.width}px;
                background: ${getColor("common.white")};

                // to make Image on the center when the card height more than 198px
                display: flex;
                align-items: center;
                justify-content: center;
            `,
        },
        productImage: {
            linkWrappingImage: {
                css: css`
                    width: 100%;
                    height: ${imageSize.height}px;
                `,
            },
            image: {
                css: css`
                    width: 100%;
                    img {
                        width: auto;
                        height: auto;
                        max-width: 100%;
                        max-height: 100%;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                    }
                `,
            },
        },
    },
    subInformationWrapper: {
        wrapper: {
            css: css`
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                &&& > div {
                    margin-bottom: 10px;
                    &:last-child {
                        margin-bottom: 0;
                    }
                }

                padding: ${(props: any) => (props.hasAttribute ? "25px 20px 0 0;" : "25px 20px 25px 0;")};
            `,
        },
        compareAndAddToCartContainer: {
            wrapper: {
                css: css`
                    flex-direction: row;
                    justify-content: flex-start;

                    display: inline-flex;
                    flex-wrap: wrap;

                    margin: 16px 0 0 -35px;
                    width: calc(100% + 35px);

                    & > * {
                        margin: 0 0 0 35px;
                    }
                `,
            },
            compareCheckbox: {
                ...checkboxDefaultTheme,
                typographyProps: {
                    size: 14,
                    color: "secondary",
                    css: css`
                        letter-spacing: 0;
                        line-height: 22px;
                    `,
                },
            },
            addToListLink: {
                ...customProductListActionsStyle.addToListLink,
            },
        },
    },
    subActionWrapper: {
        productListActions: {
            quantityOrdered: {
                ...customProductListActionsStyle.quantityOrdered,
                cssOverrides: {
                    ...customProductListActionsStyle.quantityOrdered,
                    formField: css`
                        ${customProductListActionsStyle.quantityOrdered?.cssOverrides?.formField}
                        max-width: 100%;
                        flex-basis: 100%;
                    `,
                },
            },
        },
    },
};

export default customProductCardStyles;
